import React, { useState, useEffect } from 'react';
import api from '../services/api';

export default function Temuan() {
  const [garduList, setGarduList] = useState([]);
  const [selectedGI, setSelectedGI] = useState('');
  const [temuan, setTemuan] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [filterStatus, setFilterStatus] = useState('semua');
  const [filterModul, setFilterModul] = useState('semua');
  const [bulan, setBulan] = useState(0);
  const [tahun, setTahun] = useState(new Date().getFullYear());
  const bulanList = ['Semua','Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'];

  useEffect(() => { loadGarduList(); }, []);
  useEffect(() => { if (selectedGI) loadTemuan(); }, [selectedGI]);

  const loadGarduList = async () => {
    try {
      const res = await api.get('/gardu');
      setGarduList(res.data.data || []);
      if (res.data.data?.length > 0) setSelectedGI(res.data.data[0].id);
    } catch (err) { console.error(err); }
  };

  const loadTemuan = async () => {
    setIsLoading(true);
    try {
      const res = await api.get(`/temuan/gi/${selectedGI}`);
      setTemuan(res.data.data || []);
    } catch (err) { console.error(err); setTemuan([]); }
    setIsLoading(false);
  };

  const updateStatus = async (id, status) => {
    const prevTemuan = temuan;
    setTemuan(prev => prev.map(t => t.id === id ? { ...t, status } : t));
    try {
      await api.put(`/temuan/${id}/status`, { status });
    } catch (err) {
      console.error(err);
      setTemuan(prevTemuan);
    }
  };

  const filteredTemuan = temuan.filter(t => {
    if (bulan > 0) {
      const tglTemuan = new Date(t.tgl_temuan);
      if (tglTemuan.getMonth() + 1 !== bulan || tglTemuan.getFullYear() !== tahun) return false;
    }
    const statusOk = filterStatus === 'semua' || t.status === filterStatus;
    const modulOk = filterModul === 'semua' || t.modul === filterModul;
    return statusOk && modulOk;
  });

  const getStatusBadge = (status) => {
    switch (status) {
      case 'closed': return 'bg-green-100 text-green-700';
      case 'in_progress': return 'bg-yellow-100 text-yellow-700';
      default: return 'bg-red-100 text-red-700';
    }
  };

  const getStatusLabel = (status) => {
    switch (status) {
      case 'closed': return 'Selesai';
      case 'in_progress': return 'Proses';
      default: return 'Open';
    }
  };

  const getRisikoBadge = (risiko) => {
    switch (risiko) {
      case 'tinggi': case 'kritis': return 'bg-red-100 text-red-700';
      case 'sedang': return 'bg-orange-100 text-orange-700';
      default: return 'bg-green-100 text-green-700';
    }
  };

  const formatTanggal = (tgl) => {
    try {
      return new Date(tgl).toLocaleDateString('id-ID', { day: '2-digit', month: 'long', year: 'numeric' });
    } catch { return tgl; }
  };

  const open = temuan.filter(t => t.status === 'open').length;
  const inProgress = temuan.filter(t => t.status === 'in_progress').length;
  const closed = temuan.filter(t => t.status === 'closed').length;

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-3 bg-green-50 rounded-xl px-5 py-3 border border-green-100">
        <div>
          <h1 className="text-xl font-bold text-gray-800">Temuan Inspeksi</h1>
          <p className="text-gray-500 text-xs mt-0.5">Kelola dan pantau tindak lanjut temuan</p>
        </div>
      </div>

      {/* Filter GI */}
      <div className="bg-white rounded-xl p-3 shadow-sm border border-gray-100 mb-3">
        <div className="flex flex-wrap gap-3 items-end">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Gardu Induk</label>
            <select value={selectedGI} onChange={(e) => setSelectedGI(e.target.value)}
              className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
              {garduList.map(gi => <option key={gi.id} value={gi.id}>{gi.nama}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Status</label>
            <select value={filterStatus} onChange={(e) => setFilterStatus(e.target.value)}
              className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
              <option value="semua">Semua Status</option>
              <option value="open">Open</option>
              <option value="in_progress">Proses</option>
              <option value="closed">Selesai</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Modul</label>
            <select value={filterModul} onChange={(e) => setFilterModul(e.target.value)}
              className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500">
              <option value="semua">Semua Modul</option>
              <option value="APAR">APAR</option>
              <option value="P3K">P3K</option>
              <option value="APD">APD</option>
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Bulan</label>
            <select value={bulan} onChange={(e) => setBulan(parseInt(e.target.value))}
              className="px-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm">
              {bulanList.map((b, i) => <option key={i} value={i}>{b}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1">Tahun</label>
            <select value={tahun} onChange={(e) => setTahun(parseInt(e.target.value))}
              className="px-3 py-1.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 text-sm">
              {[2025, 2026, 2027].map(y => <option key={y} value={y}>{y}</option>)}
            </select>
          </div>
        </div>
      </div>

      {/* Statistik */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 flex divide-x divide-gray-100 mb-3">
        <div className="flex-1 p-3 text-center">
          <p className="text-xl font-bold font-mono text-gray-800">{temuan.length}</p>
          <p className="text-[10px] text-gray-400 tracking-wide">TOTAL</p>
        </div>
        <div className="flex-1 p-3 text-center">
          <p className="text-xl font-bold font-mono text-red-600">{open}</p>
          <p className="text-[10px] text-gray-400 tracking-wide">OPEN</p>
        </div>
        <div className="flex-1 p-3 text-center">
          <p className="text-xl font-bold font-mono text-yellow-600">{inProgress}</p>
          <p className="text-[10px] text-gray-400 tracking-wide">PROSES</p>
        </div>
        <div className="flex-1 p-3 text-center">
          <p className="text-xl font-bold font-mono text-green-600">{closed}</p>
          <p className="text-[10px] text-gray-400 tracking-wide">SELESAI</p>
        </div>
      </div>

      {/* Tabel Temuan */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100">
        <div className="p-4 border-b border-gray-100 flex justify-between items-center">
          <h2 className="font-bold text-gray-800">Daftar Temuan ({filteredTemuan.length})</h2>
          <button onClick={loadTemuan} className="text-green-700 hover:text-green-900 text-sm">🔄 Refresh</button>
        </div>
        {isLoading ? (
          <div className="flex justify-center p-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-green-600"></div>
          </div>
        ) : filteredTemuan.length === 0 ? (
          <div className="text-center py-12 text-gray-400">
            <p className="text-4xl mb-2">✅</p>
            <p>Tidak ada temuan</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-3 py-2 text-left text-[10px] font-semibold text-gray-500 uppercase">Judul</th>
                  <th className="px-3 py-2 text-center text-[10px] font-semibold text-gray-500 uppercase">Modul</th>
                  <th className="px-3 py-2 text-center text-[10px] font-semibold text-gray-500 uppercase">Risiko</th>
                  <th className="px-3 py-2 text-center text-[10px] font-semibold text-gray-500 uppercase">Status</th>
                  <th className="px-3 py-2 text-left text-[10px] font-semibold text-gray-500 uppercase">Tanggal</th>
                  <th className="px-3 py-2 text-left text-[10px] font-semibold text-gray-500 uppercase">Petugas</th>
                  <th className="px-3 py-2 text-center text-[10px] font-semibold text-gray-500 uppercase">Aksi</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {filteredTemuan.map((item, index) => (
                  <tr key={index} className="hover:bg-gray-50">
                    <td className="px-3 py-2.5">
                      <p className="font-medium text-gray-900 text-xs">{item.judul}</p>
                      <p className="text-[10px] text-gray-500 mt-0.5 truncate max-w-xs">{item.deskripsi}</p>
                    </td>
                    <td className="px-3 py-2.5 text-center">
                      <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded text-[10px] font-bold">{item.modul}</span>
                    </td>
                    <td className="px-3 py-2.5 text-center">
                      <span className={`px-2 py-0.5 rounded text-[10px] font-bold ${getRisikoBadge(item.tingkat_risiko)}`}>
                        {item.tingkat_risiko?.toUpperCase()}
                      </span>
                    </td>
                    <td className="px-3 py-2.5 text-center">
                      <span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${getStatusBadge(item.status)}`}>
                        {getStatusLabel(item.status)}
                      </span>
                    </td>
                    <td className="px-3 py-2.5 text-xs text-gray-600">{formatTanggal(item.tgl_temuan)}</td>
                    <td className="px-3 py-2.5 text-xs text-gray-600">{item.petugas}</td>
                    <td className="px-3 py-2.5 text-center">
                      <select
                        value={item.status}
                        onChange={(e) => updateStatus(item.id, e.target.value)}
                        className="text-xs border border-gray-300 rounded px-2 py-1 bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="open">Open</option>
                        <option value="in_progress">Proses</option>
                        <option value="closed">Selesai</option>
                      </select>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
